var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 23,
    viewBox: "0 0 91 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41016 3.47272C3.99188 3.47272 0.410156 7.05444 0.410156 11.4727C0.410156 15.891 3.99188 19.4727 8.41016 19.4727C12.8284 19.4727 16.4102 15.891 16.4102 11.4727C16.4102 7.05444 12.8284 3.47272 8.41016 3.47272ZM9.2789 16.792V14.578C9.2789 14.35 9.1649 14.236 8.9369 14.236H7.3349C7.0949 14.236 6.9749 14.356 6.9749 14.596V16.774C6.9749 17.038 7.0949 17.17 7.3349 17.17H8.9369C9.1649 17.17 9.2789 17.044 9.2789 16.792ZM9.2609 12.688V12.22C9.2609 11.932 9.4169 11.644 9.7289 11.356L10.9529 10.366C11.4929 9.89804 11.7629 9.37004 11.7629 8.78204V8.53004C11.7629 7.59404 11.5049 6.87404 10.9889 6.37004C10.4729 5.86604 9.7409 5.61404 8.7929 5.61404H7.7309C6.7829 5.61404 6.0509 5.86604 5.5349 6.37004C5.0189 6.87404 4.7609 7.59404 4.7609 8.53004V8.94404C4.7609 9.20804 4.8869 9.34004 5.1389 9.34004H6.6689C6.9209 9.34004 7.0469 9.20804 7.0469 8.94404V8.56604C7.0469 8.18204 7.1249 7.91204 7.2809 7.75604C7.4489 7.60004 7.7189 7.52204 8.0909 7.52204H8.4149C8.8109 7.52204 9.09291 7.60604 9.2609 7.77404C9.4409 7.93004 9.5309 8.19404 9.5309 8.56604V8.67404C9.5309 9.03404 9.3389 9.36404 8.9549 9.66404L7.9469 10.492C7.6349 10.744 7.4129 10.996 7.2809 11.248C7.1489 11.488 7.0829 11.806 7.0829 12.202V12.688C7.0829 12.94 7.2089 13.066 7.4609 13.066H8.88291C9.1349 13.066 9.2609 12.94 9.2609 12.688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.d31778daf4cb6df59d7813af0f26c8fe.svg";
export { ForwardRef as ReactComponent };